import { DependencyModel } from '@bryntum/gantt';

export default class GanttDependency extends DependencyModel {
  static get fields() {
    return [
      { name: "toSide", persist: false }, // exclude from save
      { name: "fromSide", persist: false }, // exclude from save
    ];
  }

}